import { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Typography from "@material-ui/core/Typography";

// Form
import SmarthopForm from "@smarthop/form/SmarthopForm";
import { relayScheduleForm } from "@smarthop/form/configs/relayScheduleForm";

// Service
import { signInWithToken } from "app/services/LoginService";

// Utils
import { showSnackbar } from "app/main/utils/snackbarUtil";
import { incrementDataRevision } from "app/store/tools/revisionSlice";
import { setUserData } from "app/store/auth/userSlice";

function RelayScheduleView(props) {
	const dispatch = useDispatch();
	const snackbar = useSnackbar();

	const hasSubaccounts = useSelector(({ auth }) => auth.account.subAccount?.hasSubaccounts);
	const user = useSelector(({ auth }) => auth.user);

	const native = window?.ReactNativeWebView ?? false;

	const dataIds = props?.dataIds;
	const onDone = props?.onDone;

	const mode = dataIds?.mode;
	const carrierId = dataIds?.carrierId;
	const relayScheduleId = dataIds?.relayScheduleId || dataIds?.id;
	const historyData = dataIds?.historyData;
	const fromCalendar = dataIds?.fromCalendar;

	const isCreate = mode === "CREATE";

	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		props?.setTitle?.(historyData ? "View Relay Schedule" : isCreate ? "Add New Schedule" : "Edit Relay Schedule");
		props?.setSize?.("max-w-4xl");
		// eslint-disable-next-line
	}, []);

	const form = useMemo(() => relayScheduleForm({ user }), [user]);

	if (loading) {
		return (
			<div className="flex w-full h-512 flex-col items-center justify-center">
				<Typography color="primary" className="text-13 font-light mx-20 py-6 md:pb-48">
					Loading...
				</Typography>
			</div>
		);
	}

	if (error) {
		return (
			<div className="flex w-full h-512 flex-col items-center justify-center">
				<Typography className="w-full text-center" color="error">
					{error}
				</Typography>
			</div>
		);
	}

	return (
		<div className="mt-15">
			<SmarthopForm
				form={form}
				dataIds={{ ...dataIds, carrierId }}
				data={data}
				mode={historyData ? "COMPARE" : mode}
				onDone={() => {
					if (isCreate) {
						signInWithToken().then((userData) => {
							if (userData) dispatch(setUserData(userData, { skip_settings_set: true }));
						});
					}

					showSnackbar(snackbar, "Successfully Saved Relay Schedule", "success");

					dispatch(incrementDataRevision({ event: "profileRevision" }));
					dispatch(incrementDataRevision({ event: "relayScheduleRevision" }));
					dispatch(incrementDataRevision({ event: "dataRevision" }));
					if (fromCalendar) dispatch(incrementDataRevision({ event: "dashboardRevision" }));
					if (native) window?.ReactNativeWebView?.postMessage(JSON.stringify({ type: "REFRESH_RELAY_SCHEDULE_LIST" }));
					onDone?.();
				}}
				onProgress={(progress) => {
					setProcessing(progress);
				}}
			/>
		</div>
	);
}

export default RelayScheduleView;
